import { useCallback } from "react";
import type { SetterOrUpdater } from "recoil";
import { atomFamily, useSetRecoilState } from "recoil";

import { useFormRequest } from "../../../../actions/data";
import type { BodyData, Form } from "../../../../types/main.d";
import type { ContactsListType } from "../types";

export const declineContactFormRequest = atomFamily<Form.Request, number>({
  key: "declineContactFormRequest",
  default: {
    status: "DEFAULT",
  },
});

export const useDeclineContactFormSubmit = (
  userId: number,
  setContactsData: SetterOrUpdater<ContactsListType>
) => {
  const setFormRequest = useSetRecoilState(declineContactFormRequest(userId));
  const declineContactFormSubmit = useFormRequest({
    setFormRequest,
    url: `/users/declinecontact/${userId}/`,
  });
  return useCallback(
    (bodyData: BodyData) =>
      declineContactFormSubmit(bodyData).then((successData) =>
        setContactsData((currVal) => ({
          ...currVal,
          response: currVal.response.map((v) =>
            v.id === userId
              ? {
                  ...v,
                  ...successData,
                }
              : v
          ),
        }))
      ),
    [declineContactFormSubmit, setContactsData, userId]
  );
};
